// AUTO-GENERATED by analysis/cryptic/gen_conditions.py — do not hand-edit.
// Pre-determined 10-puzzle test CONDITIONS (24-game model): 9 fixed groups, each one
// puzzle per difficulty band (decile 0 hardest … 9 easiest). A session is allocated ONE
// whole group at random. Built from 98 puzzles (90 used across 9 groups; 8 leftover stay free-play only).

export const REBUS_CONDITIONS: string[][] = [
  ['21_6', '9_5', '5_8', '12_9', '25_8', 'puzzle114.gif', 'p58', 'p32', '14_10', '8_12'],
  ['24_10', '18_12', '8_7', '20_3', '4_5', 'puzzle28.gif', 'p30', '8_2', '1_11', '5_3'],
  ['6_6', 'p29', 'p18', '25_3', '3_2', '3_7', '22_9', '26_6', 'puzzle33.gif', 'p94'],
  ['11_6', '26_11', 'puzzle44.gif', '11_11', 'p37', '23_2', 'p50', '17_9', 'puzzle128.gif', 'p15'],
  ['22_4', '20_8', 'p14', '23_7', 'p48', '15_3', '1_6', '16_11', '26_1', 'p93'],
  ['24_5', '12_4', 'puzzle133.gif', 'p57', 'p64', 'p47', 'p101', '3_12', 'puzzle39.gif', '6_11'],
  ['15_8', 'p82', '16_6', '21_11', 'puzzle55.gif', '13_12', 'puzzle124.gif', '14_5', '2_9', 'p77'],
  ['19_5', '1_1', '18_7', '16_1', '7_4', '6_1', '2_4', 'puzzle119.gif', '10_8', 'p20'],
  ['17_4', '9_10', 'p39', '10_3', '4_10', '7_9', 'p31', '18_2', '21_1', 'p56'],
]
